import { RouteConfig } from 'vue-router'

const Entry = () => import('../views/sousou-entry/index.vue')

export const entryRoute: RouteConfig = {
  path: '/sousou-entry',
  name: 'sousou_entry',
  component: Entry,
  props: (route) => ({
    ...route.query,
    ...route.params,
  }),
  meta: {
    title: '报名参赛',
  },
}

export default [entryRoute]
